<template>
  <div><h1>Setup page</h1></div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
